import { RootState } from '€slices/types';

export const getTokenExpired = (state: RootState) => state.auth.tokenExpired;
export const validatingTokenExpired = (state: RootState) => state.auth.requestingValidateAuthCookie;
export const loggingIn = (state: RootState) => state.auth.requestingLogin;
export const loginFailed = (state: RootState) => state.auth.requestingLoginFailed;
